export const GET_APPOINTMENT_DATA = ' GET_APPOINTMENT_DATA'
export const GET_PROJECT_DATA = 'GET_PROJECT_DATA'
export const GET_FAVOURITE_DATA = 'GET_FAVOURITE_DATA'
export const POST_REQCANCEL_DATA = 'POST_REQCANCEL_DATA'
export const POST_RECEIPT_DATA = 'POST_RECEIPT_DATA'
export const POST_PAYMENT_PROJECT = 'POST_PAYMENT_PROJECT'
